
import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Typography from '@material-ui/core/Typography';
import { splitEvery, range, compose, contains, find } from 'ramda';

const getPaginationRanges = compose(splitEvery(8), range(1));

class Pagination extends PureComponent {

    render() {
        const { currentPage, numberOfPages, pageSize, resultCount, classes, onClick: _onClick, onFocus = () => { } } = this.props;
        const onClickFn = val => event => _onClick(val);
        const pageRanges = getPaginationRanges(numberOfPages + 1);
        const range = find(contains(currentPage), pageRanges);
        const hasMorePages = range[range.length - 1] !== numberOfPages;
        const from = ((currentPage - 1) * pageSize) + 1;
        const to = currentPage !== numberOfPages ? currentPage * pageSize : resultCount
        return (
            <Grid container className={classes.gridContainer}>
                <Grid item  xs={12}>
                    <Grid container   justify={'center'}>
                        <Grid item md={1} xs={2}>
                            <Button
                                variant="fab"
                                className={classes.button}
                                classes={{ fab: classes.fab, root: classes.buttonRoot }}
                                aria-label="add"
                                disabled={currentPage === 1}
                                disableRipple
                                onClick={onClickFn(currentPage - 1)}
                            >
                                <ChevronLeft  className={classes.chevrons}/>
                            </Button>
                        </Grid>
                        <Grid item md={10} xs={8}>
                            <Grid container spacing={24} justify={'center'}>
                                {
                                    range.map((option, i) => {
                                        const isSelected = option === currentPage;
                                        const buttonOpts = {
                                            className: isSelected ? classes.selected : classes.buttonDefault,
                                            color: isSelected ? 'secondary' : 'default',
                                            size: isSelected ? 'small' : 'small',
                                            variant: isSelected ? 'raised' : 'flat',
                                            fullWidth: true,
                                            disableRipple: true,
                                            'data-index': i,
                                            'data-selected': isSelected,
                                            onFocus,
                                            onClick: onClickFn(option)
                                        };
                                            return <Grid item xs={1} key={i}>
                                            <Button {...buttonOpts}>{option}</Button>
                                        </Grid>;
                                    })
                                }
                                {
                                    !hasMorePages
                                        ? null
                                        : <Grid item xs={1} >
                                            <div className={classes.ellipse}>...</div>
                                        </Grid>
                                }
                                {
                                !hasMorePages
                                        ? null
                                        : <Grid item xs={1} >
                                            <Button {...{
                                                className: classes.buttonDefault,
                                                color:  'default',
                                                size: 'small',
                                                variant: 'flat',
                                                fullWidth: true,
                                                disableRipple: true,
                                                'data-selected': false,
                                                onFocus,
                                                onClick: onClickFn(numberOfPages)
                                            }}>{numberOfPages}</Button>
                                        </Grid>
                                }
                            </Grid>
                        </Grid>
                        <Grid item md={1} xs={2} >
                                <Button
                                    disabled={currentPage === numberOfPages}
                                    variant="fab"
                                    aria-label="add"
                                    className={classes.button}
                                    classes={{ fab: classes.fab, root: classes.buttonRoot }}
                                    onClick={onClickFn(currentPage + 1)}
                                    disableRipple
                                >
                                    <ChevronRight className={classes.chevrons} />
                                </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid
                        container
                        alignItems={'center'}
                        justify={'center'}
                    >
                       <Grid item>
                                <Typography className={classes.resultRange}>
                                    <span style={{ fontWeight: 600 }}> {from} - {to} </span> of {resultCount} results
                                </Typography>
                       </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

const styles = (theme) => ({
    resultRange: {
        color: '#75787B'
    },
    button: {
        margin: theme.spacing.unit,
        '&:hover': {
            backgroundColor: '#fff'
        },
    },
    fab: {
        border: '2px solid #E6E7E8',
        backgroundColor: '#fff',
        boxShadow: theme.shadows[0],
        '&:active': {
            boxShadow: theme.shadows[0],
        },
        width: '40px',
        height: '40px'
    },
    buttonDefault: {
        'margin-top': theme.spacing.unit + 4,
        minWidth: '100%',
        minHeight: '36px',
        '&:hover': {
            backgroundColor: '#fff'
        },
    },
    ellipse: {
        'margin-top': theme.spacing.unit + 13,
        minWidth: '100%'
    },
    chevrons: {
        color: theme.palette.primary.main,
    },
    gridContainer: {
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            padding: '0px'
        }
    },
    selected: {
        border: `1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        'margin-top': theme.spacing.unit + 4,
        minWidth: '100%',
        minHeight: '36px',
        boxShadow: theme.shadows[0],
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor: '#fff',
            color: theme.palette.primary.main
        }
    }
});

export default withStyles(styles)(Pagination);



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js